import React from 'react'
import { useAppSelector } from '@SonarCX/hooks/redux'

import Column from '../Column'

import { selectCategory } from '@SonarCX/slices/category'
import { selectTaskPriority } from '@SonarCX/slices/priority'
import { selectTaskStatus } from '@SonarCX/slices/taskStatus'
import { selectTaskType } from '@SonarCX/slices/taskType'
import { selectTeams } from '@SonarCX/slices/teamsSlice'
import { useTaskCardState } from '@SonarCX/providers/TaskCardStateProvider'
import useStyles from './styles'

const Columns: React.FC = () => {
  const { categoriesValues: categories } = useAppSelector(selectCategory)
  const { priorities } = useAppSelector(selectTaskPriority)
  const { statuses } = useAppSelector(selectTaskStatus)
  const { typesValues: types } = useAppSelector(selectTaskType)
  const { teams } = useAppSelector(selectTeams)

  const { filterID } = useTaskCardState()

  const groups: { id: string; name: string; private?: boolean }[] =
    React.useMemo(() => {
      if (filterID === 'category_id') {
        return categories
      }

      if (filterID === 'priority_id') {
        return priorities
      }

      if (filterID === 'status_id') {
        return statuses
      }

      if (filterID === 'type_id') {
        return types
      }

      if (filterID === 'team_id') {
        return teams
      }

      return []
    }, [filterID, categories, priorities, statuses, types, teams])

  const hasPrivate = React.useMemo(() => {
    if (groups.length === 0) {
      return false
    }

    return 'private' in groups[0]
  }, [groups])

  const [publicValues, privateValues] = React.useMemo(() => {
    if (!hasPrivate) {
      return [groups, []]
    }

    const publicVals: typeof groups = []
    const privateVals: typeof groups = []
    groups.forEach(val => {
      if (val.private) {
        privateVals.push(val)
      } else {
        publicVals.push(val)
      }
    })

    return [publicVals, privateVals]
  }, [hasPrivate, groups])

  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Column value={{ id: null, name: 'No Category' }} isNone />

      {publicValues.map(value => (
        <Column key={value.id} value={value} />
      ))}

      {privateValues.map(value => (
        <Column key={value.id} value={value} isPrivate />
      ))}
    </div>
  )
}

export default Columns
